import {useNavigation} from '@react-navigation/native';
import * as React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../hooks/styles';
import {DeviceSize} from '../../../../theme/helpers';
import {Button} from '../../../button';
import {AcceptorsFilterList} from '../../components/list';
import {AcceptorsFilterViewBaseProps} from '../../model';

export const AcceptorsFilterMobile: React.FC<AcceptorsFilterViewBaseProps> = ({acceptorCategories}) => {
  const navigation = useNavigation();

  const styles = useStyles(({theme, mediaOnly}) => ({
    container: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      paddingTop: 35,
      paddingHorizontal: 35,
    },
    filterButtonContainer: {
      marginTop: 5,
      paddingVertical: 12,
      paddingHorizontal: 0,
      justifyContent: 'center',
      alignItems: 'center',
      borderTopWidth: 1,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    filterButton: mediaOnly(DeviceSize.mobile, {width: '100%'}, {width: 328}),
  }));

  return (
    <View style={styles.container}>
      <AcceptorsFilterList acceptorCategories={acceptorCategories} />
      <View style={[styles.filterButtonContainer]}>
        <Button
          id='filter-show'
          text='Показать'
          type='secondary'
          style={styles.filterButton}
          onPress={() => navigation.goBack()}
        />
      </View>
    </View>
  );
};
